import React, { useEffect } from 'react';
import {
  Drawer,
  Form,
  Button,
  SelectPicker,
  Message,
} from 'rsuite';
import { useTranslation } from 'react-i18next';

interface FilterDrawerProps {
  open: boolean;
  onClose: () => void;
  onFiltersChange: (filters: any) => void;
  onResetFilters: () => void;
  currentFilters: {
    type: string;
    islamic: string;
    recurrent: string;
  };
  toaster: any;
}

const FilterDrawer: React.FC<FilterDrawerProps> = ({
  open,
  onClose,
  onFiltersChange,
  onResetFilters,
  currentFilters,
  toaster
}) => {
  const [formValue, setFormValue] = React.useState(currentFilters);
  const { t } = useTranslation();


  const typeOptions = [
    { label: t('ALL'), value: '' },
    { label: t('PAID'), value: 'paid' },
    { label: t('UNPAID'), value: 'unpaid' },
    { label: t('RELIGIOUS'), value: 'religious' },
    { label: t('NATIONAL'), value: 'national' }
  ];

  const booleanOptions = [
    { label: t('ALL'), value: '' },
    { label: t('YES'), value: 'true' },
    { label: t('NO'), value: 'false' }
  ];

  const handleSubmit = () => {
    const hasFilters = Object.values(formValue).some(value => value !== '' && value !== null);
    
    if (hasFilters) {
      onFiltersChange({
        type: formValue.type,
        islamic: formValue.islamic,
        recurrent: formValue.recurrent
      });
      toaster.push(
        <Message type="success" duration={3000}>
          {t('Filters applied successfully!')}
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      onResetFilters();
    }
    onClose();
  };

  const handleReset = () => {
    setFormValue({
      type: '',
      islamic: '',
      recurrent: ''
    });
    onResetFilters();
    toaster.push(
      <Message type="info" duration={3000}>
        {t('Filters have been reset!')}
      </Message>,
      { placement: 'topCenter' }
    );
    onClose();
  };

  useEffect(() => {
    if (open) {
      setFormValue(currentFilters);
    }
  }, [open, currentFilters]);

  return (
    <Drawer 
      backdrop="static" 
      size="sm" 
      placement="right" 
      onClose={onClose} 
      open={open}
    >
      <Drawer.Header>
        <Drawer.Title>{t('Filter Holidays')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={handleReset} appearance="subtle">
            {t('Reset')}
          </Button>
          <Button onClick={handleSubmit} appearance="primary">
            {t('Apply')}
          </Button>
          <Button onClick={onClose} appearance="subtle">
            {t('Cancel')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form fluid formValue={formValue} onChange={setFormValue}>
          <Form.Group>
            <Form.ControlLabel>{t('Holiday Type')}</Form.ControlLabel>
            <Form.Control 
              name="type" 
              accepter={SelectPicker}
              data={typeOptions}
              searchable={false}
              placeholder={t("Select type")}
              block
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t('Islamic')}</Form.ControlLabel>
            <Form.Control 
              name="islamic"
              accepter={SelectPicker}
              data={booleanOptions}
              searchable={false}
              placeholder={t("Select Islamic status")}
              block
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t('Recurrent')}</Form.ControlLabel>
            <Form.Control 
              name="recurrent"
              accepter={SelectPicker}
              data={booleanOptions}
              searchable={false}
              placeholder={t("Select recurrent status")}
              block
            />
          </Form.Group>
        </Form>
      </Drawer.Body>
    </Drawer>
  );
};

export default FilterDrawer;